export default __webpack_public_path__ + "static/media/Emma-5a662db9bcf55809a1fefb2ea17634bc.add10415.png";